import travelClient from './travelClient';
import { travelEndpoints } from './endpoints';

/**
 * 保留自訂地／geo snowflake ID 精度。
 */
function parseTravelJson(raw) {
  if (typeof raw !== 'string' || !raw) return raw;
  const text = raw.replace(
    /("(?:locationId|linkedLocationId|customLocationId|id)"\s*:\s*)(\d{15,})/g,
    '$1"$2"',
  );
  return JSON.parse(text);
}

const snowflakeJson = { transformResponse: [parseTravelJson] };

/**
 * PD-LOC-01 自訂地點 API。
 * 建立後使用 linkedLocationId 寫入 Activity；禁止把 status 工程名直接塞進 runtime 文案以外的提示。
 */
export const customLocationApi = {
  create: (body) => travelClient.post(travelEndpoints.customLocations, body, snowflakeJson),
  listMine: () => travelClient.get(travelEndpoints.customLocationsMine, snowflakeJson),
  submitPublic: (id) => travelClient.post(travelEndpoints.customLocationSubmitPublic(id), {}, snowflakeJson),
  searchPublic: (q) => travelClient.get(travelEndpoints.customLocationsPublicSearch, {
    params: { q },
    ...snowflakeJson,
  }),
};
